export default "__VITE_ASSET__DRrnoTXi__"